import { createPitchEditingAction } from "@/data/conversion/actions/createPitchEditingSessionAction";
import { Cover, SelectedFile } from "@/types/types";
import { stringifyDatesSelectedFileCover } from "@/utils/serverClientSerialization/stringifyDatesSelectedFileCover";

// this is a common getter function for session slugs that is used in both the auto-tuner and harmony maker session slugs are how the de-hubertizer knows which hubert to dehubertize
export const sessionSlugGetter =
  (selectedFileCover: SelectedFile | Cover | null) =>
  async (): Promise<string> => {
    if (selectedFileCover === null) {
      throw new Error("No file selected");
    }
    const { slug } = await createPitchEditingAction({
      selectedFileCover: stringifyDatesSelectedFileCover(selectedFileCover),
    });

    return slug;
  };
